import React from 'react';
import { Redirect } from 'react-router-dom';
import { compose, prop } from 'ramda';
import { branch, renderComponent } from 'recompose';

import connect from 'app/libs/connect';
import StackedLayout from 'app/components/layout/StackedLayout';
import Meta from 'app/features/landing/meta/components/Meta';
import HelpCenter from 'app/features/helpCenter/components/HelpCenter';
import { redirectUrl } from 'app/features/migration/landing/selectors';
import HeroBlock from 'app/features/migration/landing/components/HeroBlock';

const UI = () => (
  <StackedLayout>
    <Meta />
    <StackedLayout.ContentBlock>
      <HeroBlock />
    </StackedLayout.ContentBlock>
    <StackedLayout.ContentBlock>
      <HelpCenter article="/articles/4418065737492" />
    </StackedLayout.ContentBlock>
  </StackedLayout>
);

UI.displayName = 'MigrationLanding';

export { UI };

export default compose(
  connect({ to: redirectUrl }),
  branch(prop('to'), renderComponent(Redirect)),
)(UI);
